export const HELPFUL_LINKS = 'Some helpful links:';
export const MISSING_LICENSE = 'Missing license';
export const MISSING_LICENSE_DETAIL = "You don't appear to have a license for this service. Please contact your organisation admin for access.";
export const OOPS = 'Oops!';
export const PAGE_NOT_FOUND = 'Page not found';
export const PAGE_NOT_FOUND_DETAILED = 'We were unable to find the page you requested.';
export const MAINTENANCE_MODE_HEADER_DEFAULT = 'Under maintenance';
export const MAINTENANCE_MODE_BODY_DEFAULT = 'We are currently performing maintenance on this application. Please try again later.';
//# sourceMappingURL=strings.js.map